var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PaymentServiceName } from "../../../src/payment-services/_types/index";
import "../styles/index.scss";
import { Loader, request, setPageError } from "./utils";
import StripeUtils from "./stripe";
const usp = new URLSearchParams(window.location.search);
const lang = usp.get("lang");
const redirectToCheckout = (paymentService) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        switch (paymentService) {
            case PaymentServiceName.stripe:
                yield StripeUtils.goToCheckout();
                break;
            default:
        }
    }
    catch (err) {
        Loader.hide();
        setPageError();
    }
});
const handleRequiresAction = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const appUrl = ((_a = document.getElementById("app-redirect")) === null || _a === void 0 ? void 0 : _a.getAttribute("href")) || undefined;
    yield StripeUtils.handleRequiresAction(appUrl);
});
const toggleScaWarn = () => {
    var _a;
    (_a = document.querySelector(".page-content")) === null || _a === void 0 ? void 0 : _a.classList.toggle("sca-warning");
};
const attachEventHandlers = () => {
    const updatePaymentMethodBtn = document.getElementById("update-payment-method");
    const requiresActionBtn = document.getElementById("requires-action");
    const scaToggle = document.querySelectorAll(".toggle-sca");
    scaToggle.forEach((button) => {
        button.addEventListener("click", toggleScaWarn);
    });
    if (updatePaymentMethodBtn) {
        updatePaymentMethodBtn.addEventListener("click", () => {
            redirectToCheckout(PaymentServiceName.stripe);
        });
    }
    if (requiresActionBtn) {
        requiresActionBtn.addEventListener("click", handleRequiresAction);
    }
};
const fetchLanguageResource = () => __awaiter(void 0, void 0, void 0, function* () {
    const language = lang || "en";
    languageResource = yield request({
        method: "GET",
        path: `portal/language/${language}`,
    });
});
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    yield fetchLanguageResource();
    attachEventHandlers();
    if (generalError != null) {
        setPageError(generalError);
        return;
    }
    if (stripeSessionId != null) {
        Loader.show();
        StripeUtils.redirectToCheckout(stripeSessionId).catch((err) => {
            console.error(err);
            Loader.hide();
            setPageError();
        });
    }
    if (pastDueTransactionId != null) {
        Loader.show();
        window.location.replace(`${window.location.origin}/pay?_ptxn=${pastDueTransactionId}`);
        return;
    }
    const appUrlFromQuery = usp.get("appUrl") || "";
    const redirectToAppButton = document.getElementById("app-redirect");
    if (appUrlFromQuery.length > 0) {
        redirectToAppButton.classList.remove("d-none");
        redirectToAppButton.setAttribute("href", appUrlFromQuery);
    }
});
init();
